import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import LaddaButton, { ZOOM_IN } from 'react-ladda';
import { toastr } from 'react-redux-toastr'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../../../actions/auth';


import { setCookie } from '../../../cookies/';
import { COOKIE_KEY, AUTH_INFO_KEY } from '../../../config/session';

const storage = window.localStorage;

@connect(
  state => ({ auth: state.get('Auth') }),
  dispatch => bindActionCreators(actionCreators, dispatch)
)
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: '',
      password: '',
      error: ''
    };
  }
  typein = field => (e) => {
    this.setState({
      [field]: e.target.value
    });
  }
  login = () => {
    const { login } = this.props;
    const { code, password } = this.state;
    login({
      code,
      password
    })
      .then(() => {
        const { auth } = this.props;
        const error = auth.get('error');
        const data = auth.get('data');
        if (error) {
          toastr.error(error.get('message'));
          this.setState({ error: error.get('message') });
          return;
        }
        if (data.get('success')) {
          toastr.success(data.get('message'));
          storage.setItem(AUTH_INFO_KEY, JSON.stringify(data.get('data').get('user')));
          setCookie(COOKIE_KEY, data.get('data').get('token'), 7);
          browserHistory.push('/');
        } else {
          toastr.error('错误信息', data.get('message'));
        }
      });
  }
  render() {
    const { auth } = this.props;
    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="card-group mb-0">
              <div className="card p-2">
                <div className="card-block">
                  <h1>登录</h1>
                  <p className="text-muted">波科二维码后台</p>
                  <div className="input-group mb-1">
                    <span className="input-group-addon"><i className="icon-user" /></span>
                    <input type="text" onChange={this.typein('code')} className="form-control" value={this.state.code} placeholder="用户名" />
                  </div>
                  <div className="input-group mb-2">
                    <span className="input-group-addon"><i className="icon-lock" /></span>
                    <input type="password" onChange={this.typein('password')} className="form-control" value={this.state.password} placeholder="密码" />
                  </div>
                  <div className="input-group">
                    <LaddaButton
                      className="btn btn-primary btn-ladda"
                      loading={auth.get('loading')}
                      onClick={() => this.login('expZoomIn')}
                      data-color="blue"
                      data-style={ZOOM_IN}
                    >
                      登录
                    </LaddaButton>
                  </div>
                </div>
              </div>
              {/**
              <div className="card card-inverse card-primary py-3 hidden-md-down" style={{ width: '44%' }}>
                <div className="card-block text-center">
                  <div>
                    <h2>Sign up</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <button type="button" className="btn btn-primary active mt-1">Register Now!</button>
                  </div>
                </div>
              </div>
              */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/Pages/Login/index.js